/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1BannerBanneridLangsId202,
  PutApiV1BannerBanneridLangsId400,
  PutApiV1BannerBanneridLangsId401,
  PutApiV1BannerBanneridLangsId404,
  PutApiV1BannerBanneridLangsId500,
  PutApiV1BannerBanneridLangsIdMutationRequest,
  PutApiV1BannerBanneridLangsIdMutationResponse,
  PutApiV1BannerBanneridLangsIdPathParams,
} from "../../types/bannerIdiomasController/PutApiV1BannerBanneridLangsId.ts";
import { bannerLangViewModelSchema } from "../bannerLangViewModelSchema.ts";

export const putApiV1BannerBanneridLangsIdPathParamsSchema = z.object({
  bannerId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1BannerBanneridLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1BannerBanneridLangsId202Schema = z.lazy(
  () => bannerLangViewModelSchema,
) as unknown as ToZod<PutApiV1BannerBanneridLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1BannerBanneridLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1BannerBanneridLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1BannerBanneridLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1BannerBanneridLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1BannerBanneridLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1BannerBanneridLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1BannerBanneridLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1BannerBanneridLangsId500>;

export const putApiV1BannerBanneridLangsIdMutationRequestSchema = z.object({
  CultureInfo: z.optional(z.string()),
  Url: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  Image: z.optional(z.instanceof(File)),
  Video: z.optional(z.instanceof(File)),
  ImageMobile: z.optional(z.instanceof(File)),
  VideoMobile: z.optional(z.instanceof(File)),
}) as unknown as ToZod<PutApiV1BannerBanneridLangsIdMutationRequest>;

export const putApiV1BannerBanneridLangsIdMutationResponseSchema = z.lazy(
  () => putApiV1BannerBanneridLangsId202Schema,
) as unknown as ToZod<PutApiV1BannerBanneridLangsIdMutationResponse>;
